import { toast } from "react-toastify";

import { appInsights } from "services/app-insight/app-insight";
import { AppError } from ".";
import { SeverityLevel } from "@microsoft/applicationinsights-web";

export function handleError(error, options = {}) {
    const {
        showToast = true,
        toastOptions = undefined,
        onFatal,
    } = options;

    let exception = error;

    if (typeof error === "string") {
        exception = new AppError(error);
    }

    // Log once, always
    logError(exception);

    if (showToast && !error.silent) {
        toast[toastType(exception.severity)](exception.message, toastOptions);
    }

    if (exception.severity === "fatal") {
        onFatal?.(exception);
    }

    return exception;
}

function toastType(severity) {
    if (severity === "warning") return "warning";
    if (severity === "info") return "info";
    return "error";
}

function logError(exception) {
    appInsights.trackException({
        exception,
        severityLevel: exception.severity,
    });
}
